import { getJson } from './client';
import type { BmsConditioningResponse } from './types';
export const fetchBmsConditioning = () => getJson<BmsConditioningResponse>('/api/bms-conditioning');
